import { SkinColor, HairStyle, EyeColor, NPC, HairTextureOption } from '@/types/game';

export const SKIN_COLORS: SkinColor[] = [
  // Dark Tones
  { name: 'Coffee Bean', hex: '#3B2414' },
  { name: 'Ebony', hex: '#2C2C2C' },
  // Warm Brown Tones
  { name: 'Espresso', hex: '#4A2511' },
  { name: 'Mocha', hex: '#6B4C3D' },
  { name: 'Coco Brown', hex: '#6B4423' },
  { name: 'Dark Oak', hex: '#4A2E23' },
  { name: 'Light Brown', hex: '#8B6F47' },
  { name: 'Caramel', hex: '#A0826D' },
  { name: 'Brown Brick', hex: '#7C4B3D' },
  { name: 'Swampy Brown', hex: '#5C4033' },
  { name: 'Golden Bronze', hex: '#B8860B' },
  { name: 'Tan', hex: '#C89968' },
  // Pale/Light Tones
  { name: 'Pale Peach', hex: '#FDBCB4' },
  { name: 'Warm Ivory', hex: '#F5DEB3' },
  { name: 'Rose Beige', hex: '#E8C5B8' },
  { name: 'Pale Ivory', hex: '#F5E6D3' },
  { name: 'Porcelain', hex: '#F7E7D7' },
  { name: 'Peachy Pale', hex: '#F4D4C8' },
  // Other Tones
  { name: 'Deep Plum', hex: '#4A3A5C' },
  { name: 'Cool Gray', hex: '#A9A9A9' },
];

export const HAIR_STYLES: HairStyle[] = [
  { name: 'Locs', id: 'locs' },
  { name: 'Wavy Long', id: 'wavy-long' },
  { name: 'Pixie Cut', id: 'pixie' },
  { name: 'Braids', id: 'braids' },
  { name: 'Straight Long', id: 'straight-long' },
  { name: 'Curly', id: 'curly' },
  { name: 'Spiky', id: 'spiky' },
  { name: 'Space Buns', id: 'space-buns' },
  { name: 'Bob', id: 'bob' },
  { name: 'Short Bob', id: 'short-bob' },
];

export const HAIR_TEXTURES: HairTextureOption[] = [
  { name: 'Straight', id: 'straight' },
  { name: '3A Wavy', id: '3a' },
  { name: '3B Curly', id: '3b' },
  { name: '3C Coily', id: '3c' },
  { name: '4A Kinky', id: '4a' },
  { name: '4B Kinky', id: '4b' },
  { name: '4C Coily', id: '4c' },
];

export const GENDERS = [
  { name: 'Male', id: 'male' },
  { name: 'Female', id: 'female' },
  { name: 'Nonbinary (Male Presenting)', id: 'nb-male' },
  { name: 'Nonbinary (Female Presenting)', id: 'nb-female' },
  { name: 'Fem Trans', id: 'fem-trans' },
  { name: 'Male Trans', id: 'male-trans' },
];

export const OUTFIT_COLORS = [
  { name: 'Black', hex: '#000000' },
  { name: 'Deep Purple', hex: '#663399' },
  { name: 'Crimson Red', hex: '#DC143C' },
  { name: 'Midnight Blue', hex: '#191970' },
  { name: 'Dark Green', hex: '#2C5F2D' },
  { name: 'Gold', hex: '#FFD700' },
  { name: 'Silver', hex: '#C0C0C0' },
  { name: 'Copper', hex: '#B87333' },
];

export const MAKEUP_COLORS = [
  { name: 'No Makeup', hex: '#00000000' },
  { name: 'Soft Pink', hex: '#FFB6D9' },
  { name: 'Deep Red', hex: '#8B0000' },
  { name: 'Smokey Gray', hex: '#808080' },
  { name: 'Gold Shimmer', hex: '#FFD700' },
  { name: 'Burgundy', hex: '#800020' },
  { name: 'Black', hex: '#000000' },
  { name: 'Bronze', hex: '#CD7F32' },
];

export const HAIR_COLORS = [
  { name: 'Pale Teal', hex: '#7FFFD4' },
  { name: 'Blonde', hex: '#FFD700' },
  { name: 'Black', hex: '#000000' },
  { name: 'Dark Brown', hex: '#3E2723' },
  { name: 'Deep Purple', hex: '#663399' },
  { name: 'Crimson Red', hex: '#DC143C' },
  { name: 'Silver', hex: '#C0C0C0' },
  { name: 'Midnight Blue', hex: '#191970' },
];

export const EYE_COLORS: EyeColor[] = [
  { name: 'Amber', hex: '#FFBF00' },
  { name: 'Violet', hex: '#EE82EE' },
  { name: 'Emerald', hex: '#50C878' },
  { name: 'Ice Blue', hex: '#B0E0E6' },
  { name: 'Gold', hex: '#FFD700' },
  { name: 'Deep Black', hex: '#1C1C1C' },
  { name: 'Silver', hex: '#C0C0C0' },
];

export const NPCS: NPC[] = [
  {
    id: 'ei-bhaal',
    name: 'Ei Bhaal',
    race: 'dark-elf',
    description: 'A mysterious dark elf with pale teal locs and coco brown skin.',
    romanceable: true,
    romance: 'slow-burn',
  },
  {
    id: 'yichen',
    name: 'Yìchén',
    race: 'magician',
    description: 'A skilled magician with blonde short hair and peachy pale skin.',
    romanceable: true,
    romance: 'even-paced',
  },
  {
    id: 'dollia',
    name: 'Dollia',
    race: 'bosmer',
    description: 'A fierce gunslinger with a short messy pixie cut, dark brown skin, black eyes, and two scars.',
    romanceable: true,
    romance: 'even-paced',
  },
  {
    id: 'alphonse',
    name: 'Alphonse',
    race: 'dark-elf',
    description: 'A mysterious dark elf with long white hair, piercing red eyes, and an enigmatic aura.',
    romanceable: true,
    romance: 'slow-burn',
  },
  {
    id: 'sylus',
    name: 'Sylus',
    race: 'mage',
    description: 'A striking high elf with long blonde hair, sharp features, fanged teeth, and intense red eyes.',
    romanceable: true,
    romance: 'even-paced',
  },
  {
    id: 'sith',
    name: 'Sith',
    race: 'mage',
    description: 'A human with dark brown hair and tan skin.',
    romanceable: false,
    romance: 'none',
  },
  {
    id: 'nadia',
    name: 'Nadia',
    race: 'mage',
    description: 'A human Countess ruling over Vestuvia.',
    romanceable: false,
    romance: 'none',
  },
];

export const FACTIONS = [
  {
    id: 'nocturne-thorn',
    name: 'Nocturne & Thorn',
    description: 'The Mage College',
    location: 'The Lazerate',
  },
  {
    id: 'ebonveil',
    name: 'Ebonveil',
    description: 'The Magician Shop',
    location: 'The Red Market',
  },
  {
    id: 'ashen-crown',
    name: 'Ashen Crown',
    description: 'The Royal Academy',
    location: 'Vestuvia',
  },
  {
    id: 'nightspire',
    name: 'NightSpire',
    description: 'The Knight Academy',
    location: 'Vestuvia',
  },
];

export const LOCATIONS = [
  'The Red Market',
  'The Lazerate',
  'Vestuvia',
  'The Oasis',
  'The Single Cell Biom',
  'The Badlands',
  'The Mushroom Caves',
  'The Bioluminescent Caves',
  'The Split Mountains',
  'The Sickle Ink Biome',
];